var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationFailedIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.642,
    height: 25.87,
    viewBox: "0 0 20.642 25.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57086",
    "data-name": "Group 57086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gpp_maybe_FILL0_wght400_GRAD0_opsz48",
    d: "M18.321,29.82A12.666,12.666,0,0,1,10.9,24.565,15.364,15.364,0,0,1,8,15.527V7.83L18.321,3.95,28.642,7.83v7.7a15.364,15.364,0,0,1-2.9,9.038A12.666,12.666,0,0,1,18.321,29.82Z",
    transform: "translate(-8 -3.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155584",
    "data-name": "Path 155584",
    d: "M.745-4.365H-.922l-.236-7.01H.982Zm-.834,1.1a1.125,1.125,0,0,1,.816.3,1.017,1.017,0,0,1,.309.764,1.008,1.008,0,0,1-.309.757,1.125,1.125,0,0,1-.816.3,1.116,1.116,0,0,1-.809-.3A1.008,1.008,0,0,1-1.207-2.2,1.019,1.019,0,0,1-.9-2.965,1.109,1.109,0,0,1-.088-3.267Z",
    transform: "translate(10.649 19.21)",
    fill: "#cb4241"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationFailedIconMobile);
export default __webpack_public_path__ + "static/media/verification-failed-icon-mobile.fb784747f07833ab9cd418d1d489c0b5.svg";
export { ForwardRef as ReactComponent };